const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export interface Event {
  id: string;
  title: string;
  date: string;
  time?: string;
  location?: string;
  description?: string;
  image?: string;
  establishmentId: string;
  registrationsCount: number;
}

export interface EventRegistration {
  id: string;
  eventId: string;
  createdAt: string;
}

export const eventsApi = {
  async getAll(establishmentId?: string): Promise<Event[]> {
    const url = new URL(`${API_URL}/events`);
    if (establishmentId) url.searchParams.set('establishmentId', establishmentId);
    const res = await fetch(url.toString());
    if (!res.ok) throw new Error('Failed to fetch events');
    const data = await res.json();
    return data.events ?? [];
  },

  async getUserRegistrations(userId: string): Promise<EventRegistration[]> {
    const res = await fetch(`${API_URL}/users/${userId}/events`);
    if (!res.ok) throw new Error('Failed to fetch registrations');
    const data = await res.json();
    return data.registrations ?? [];
  },

  async register(userId: string, eventId: string): Promise<void> {
    const res = await fetch(`${API_URL}/users/${userId}/events/${eventId}/register`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error('Failed to register');
  },

  async unregister(userId: string, eventId: string): Promise<void> {
    const res = await fetch(`${API_URL}/users/${userId}/events/${eventId}/register`, {
      method: 'DELETE',
    });
    if (!res.ok) throw new Error('Failed to unregister');
  },
};
